const swiftInstructions = (account, coreEventName) => {
  const re = `// 1. First you should

import pmf_engine_swift

// 2. Configure with your accountId and userId in the didFinishLaunchingWithOptions
//    userId is an identifier of your user. It can be email, id, or anything else that 
//    will be the same string that identifies user.

PMFEngine.default.configure(accountId: "${account.id}", userId: UUID().uuidString)


// 3. Track Event

PMFEngine.default.trackKeyEvent()
`

  const gc = `// 4. Customize view

let popupView = PMFEnginePopupView()

popupView.emoji = UIImage(named: "smilling-panda")
popupView.title = "Pleeeeease! 🙏\n Help us to improve \nto help others!"
popupView.subTitle = "By answering a few simple questions."
popupView.confirmTitle = "Yes, happy to help!"
popupView.cancelTitle = "No, I don't want to help!"

popupView.containerBackgroundColor = UIColor.white
popupView.closeButtonTitleColor = UIColor.lightGray
popupView.pmfButtonBackgroundColor = UIColor.purple
popupView.pmfButtonTitleColor = UIColor.white

popupView.confirmFont = UIFont.systemFont(ofSize: 17, weight: .bold)
popupView.cancelFont = UIFont.systemFont(ofSize: 14, weight: .semibold)


// 5. Show Popup if needed

PMFEngine.default.showPMFPopup(popupView: popupView, onViewController: topController)
`

  return { re, gc }
}

export default swiftInstructions
